// extracted by mini-css-extract-plugin
export default {"container":"container__rfp06","main":"main__uK7+E","page-title":"page-title__+p7HX","icon":"icon__IzbzT","locked":"locked__EpW5b"};